export default __webpack_public_path__ + "static/media/singup.663c7fa6.jpg";